<script>
import DataLayer from '@services/data-layer/index'
import ChannelDetailBlock from '@components/channel/channel-detail-block'

export default {
    name: 'HomepageRadio',
    components: { ChannelDetailBlock },
    data() {
        return {
            channels: [],
            playlists: [],
        }
    },
    mounted() {
        const channelsOrder = ['chill', 'classics', 'deep', 'frisky']

        DataLayer.channels.get().then(response => {
            this.channels = Object.values(response.body).sort(
                (a, b) => channelsOrder.indexOf(a.id) - channelsOrder.indexOf(b.id)
            )
        })
        DataLayer.stationsPlaylists.subscribe(resposne => {
            this.playlists = resposne.body.reduce((playlists, item) => {
                if (!playlists[item.station]) playlists[item.station] = []
                playlists[item.station].push(item)
                return playlists
            }, {})
        })
    },
}
</script>

<template>
    <div>

        <BaseSection
            v-if="channels?.length"
            title="Radio"
        >
            <ChannelDetailBlock
                :channels="channels"
                :playlists="playlists"
                display-minimal-version
            />
        </BaseSection>
        <BaseSection
            v-else
            class="skeleton"
        >
            <div
                v-for="i in 4"
                :key="i"
                class="skeleton-tile"
            >
                <BasePlaceholder
                    type="channel"
                    tag="h6"
                    class="skeleton-title"
                />
                <div class="skeleton-cover" />
            </div>
        </BaseSection>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.skeleton {
    display: grid;
    grid-template-columns: 1fr;
    gap: $s-m;

    @include tablet {
        grid-template-columns: repeat(2, 1fr);
    }

    @include desktop {
        grid-template-columns: repeat(4, 1fr);
    }
}

.skeleton-title {
    margin: $s-s 0;
    text-align: center;
}

.skeleton-cover {
    height: 230px;
    background: currentColor;
    opacity: 0.1;
    border-radius: 2px;
}
</style>
